(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){if(event.target.closest('.rp-mobile a')){event.target.closest('details').removeAttribute('open');}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){const select=event.target.closest('[data-rp-variant]');if(!select)return;const option=select.options[select.selectedIndex];const price=document.getElementById(select.dataset.priceTarget);const button=select.form.querySelector('[data-rp-add]');if(price)price.textContent=option.dataset.price;if(button){button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.addLabel;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["we-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",function(e){const a=e.target.closest(".we-mobilepanel a");if(a)a.closest("details").open=false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["we-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){const b=e.target.closest('[data-we-image]');if(!b)return;const root=b.closest('[data-we-product]'),img=root.querySelector('.we-mainimage img'),link=root.querySelector('[data-we-zoom]');img.src=b.dataset.weImage;img.removeAttribute('srcset');link.href=b.dataset.weFull;root.querySelectorAll('[data-we-image]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));});
document.addEventListener('change',function(e){const s=e.target.closest('[data-we-variant]');if(!s)return;const o=s.options[s.selectedIndex],root=s.closest('[data-we-product]'),b=root.querySelector('[data-we-add]');root.querySelector('[data-we-price]').textContent=o.dataset.price;b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?b.dataset.soldText:b.dataset.addText;const url=new URL(location.href);url.searchParams.set('variant',s.value);history.replaceState({},'',url);const name=o.text.toLowerCase(),buttons=root.querySelectorAll('[data-we-image]');if((name.includes('complete system')||name.includes('2-pack'))&&buttons.length>=2)buttons[buttons.length-2].click();else if((name.includes('full experience')||name.includes('4-pack'))&&buttons.length)buttons[buttons.length-1].click();else if(buttons.length)buttons[0].click();});

  } catch(e) { console.error(e); }
})();
})();
